// extracted by mini-css-extract-plugin
export default {"overlay":"uZZNH_oG","scrim":"yQR5Orzc","sheet":"TIkzClUc","slideUp":"MTObrMWT","dragger":"f9Bztkf6","title":"V7TxD6yD","body":"VSdnhdTT"};